var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"text-h5 pb-4 font-weight-bold primary--text text-center header"},[_vm._v(" Welcome to Oribalt track & trace system ")]),_c('v-row',{staticClass:"truck-img-container",attrs:{"justify":"center","no-gutters":""}},[_c('div',{staticClass:"truck-img"})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }